import script from "./PetListingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PetListingPage.vue?vue&type=script&setup=true&lang=js"

import "./PetListingPage.vue?vue&type=style&index=0&id=27fa5084&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27fa5084"]])

export default __exports__